export const CONTACT = {
    email: "info@crnplanner.com",
    phone: "0451 035 423",
    phoneHref: "tel:+32451035423",
    address: "Steenweg op Oosthoven 213, 2300 Turnhout",
    mapsHref: "https://www.google.com/maps/search/?api=1&query=Steenweg+op+Oosthoven+213+2300+Turnhout",
};
